import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LocationsList from '@/features/general/LocationsList/ui/LocationsList.vue'
import { inject } from 'vue'
import { handleObjectNodeClick } from '@/pages/ObjectsView/model/handleObjectNodeClick'
import {
    ILocationList,
    LocationClickHandler,
    LocationListProps,
} from '@/features/general/LocationsList/model/LocationsList.types'
import { ITreeList } from '@/widgets/MenuPanel/ui/TreeView/methods/TreeList'

interface ObjectsViewProps
    extends Omit<LocationListProps, 'handleLocationClick'> {
    handleLocationClick: (clickedObject: ITreeList) => any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectsView',
  props: {
    handleLocationClick: { type: Function },
    locations: {},
    isLoading: { type: Boolean },
    notFoundDescription: {}
  },
  setup(__props: any) {

const props = __props

const appContext = inject('appContext')

const handleObjectNodeClickChain = (clickedObject: ITreeList) => {
    props.handleLocationClick(clickedObject)
    handleObjectNodeClick.call(appContext, clickedObject)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LocationsList, _normalizeProps(_guardReactiveProps({
                handleLocationClick: handleObjectNodeClickChain,
                locations: props.locations,
                isLoading: props.isLoading,
            })), null, 16)
  ]))
}
}

})